import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

import HeaderRight from "../Header-Right/HeaderRight";
import Search from "../Offcanvas/Search";
import Category from "../Category/Category";
import Nav from "../Nav";
import HeaderSearchBar from "../HeaderSearchBar";

import logo from "../../../public/images/logo/smarttech-full-blue.png";
import logoLight from "../../../public/images/logo/smarttech-full-white.png";
import { useAppContext } from "@/context/Context";

import { ROUTE } from "@/route/app_routes.js";









const HeaderNavigations = ({ headerType, gapSpaceBetween, sticky, headerSticky, navigationEnd, container, blendWithHero = false }) => {


  const [isSticky, setIsSticky] = useState(false);
  const { isLightTheme } = useAppContext();

  const isBlended = blendWithHero && !isSticky;
  const useLightLogo = !isLightTheme || isBlended;


  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      if (scrolled > 12) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);






  return (
    <>
      <div
        className={`rbt-header-wrapper ${gapSpaceBetween} ${sticky} ${!headerType && (isSticky || blendWithHero) ? `${headerSticky}` : ""} ${isSticky ? "rbt-header-wrapper--scrolled" : ""} ${blendWithHero ? "rbt-header-blend" : ""} ${isBlended ? "rbt-header-blend--active" : ""}`}
      >
        <div className={`${container}`}>
          <div className={`mainbar-row ${navigationEnd} align-items-center`}>


            <div className="header-left rbt-header-content">
              <div className="header-info">
                <div className="logo">
                  <Link href={ROUTE.home}>
                    {useLightLogo ? (
                      <Image
                        src={logoLight}
                        width={148}
                        height={56}
                        priority={true}
                        alt="SmartTech Academy"
                      />
                    ) : (
                      <Image
                        src={logo}
                        width={148}
                        height={56}
                        priority={true}
                        alt="SmartTech Academy"
                      />
                    )}
                  </Link>
                </div>
              </div>

              <div className="header-info rbt-nav-explore d-none d-lg-block">
                <Category />
              </div>
            </div>



            <div className="rbt-main-navigation d-none d-xl-block">
              <Nav />
            </div>

            <div className="rbt-header-search-wrap d-none d-lg-block">
              <HeaderSearchBar />
            </div>

            <HeaderRight userType="Admin" btnText="Enroll Now" btnClass="rbt-marquee-btn marquee-auto btn-border-gradient radius-round btn-sm hover-transform-none" />

          </div>
        </div>
        <Search />
      </div>
    </>
  );
};

export default HeaderNavigations;
